<template>
  <div class="file-uploader__dropzone-list">
    <div
      v-for="quality in qualityArray"
      :key="quality"
      class="file-uploader__dropzone-list-item"
    >
      <p class="file-uploader__quality-label">{{ `${quality}p:` }}</p>

      <div
        class="files-uploader__select-row"
        @click="onSelectelUploaderClick(quality)"
      >
        <input
          v-model="filesDictionary[quality].type"
          type="radio"
          :value="URL"
          :name="`uploadVideoGroup${quality}`"
        >
        <SelectelUploader
          :file-link="filesDictionary[quality].url"
          :selectel-list="selectelList"
          :selectel-loading="selectelLoading"
          :link-status="filesDictionary[quality].linkStatus"
          @blur="checkLink(quality)"
          @file-attached="attachFile($event, quality)"
        />
      </div>

      <div
        class="files-uploader__select-row"
        @click="onFileUploaderClick(quality)"
      >
        <input
          v-model="filesDictionary[quality].type"
          type="radio"
          :value="FILE"
          :name="`uploadVideoGroup${quality}`"
        >
        <Dropzone
          :id="`files-uploader-${quality}`"
          :ref="`dropzone${quality}`"
          class="dropzone-noprogress"
          :options="dropzoneOptions"
          @vdropzone-removed-file="videoRemoved($event, quality)"
          @vdropzone-file-added="videoAdded($event, quality)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone';
import SelectelUploader from './SelectelUploader';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import { FILE, URL } from './constants';

export default {
  name: 'VideoQualityUploader',

  components: {
    Dropzone,
    SelectelUploader,
  },

  props: {
    checkType: {
      type: String,
      required: true,
    },
    dropzoneOptions: {
      type: Object,
      required: true,
    },
    qualityArray: {
      type: Array,
      default: () => ([
        144,
        240,
        360,
        480,
        720,
        1080,
      ]),
    },
    selectelList: {
      type: Object,
      default: null,
    },
    selectelLoading: {
      type: Boolean,
      default: false,
    },
    defaultFiles: {
      type: Object,
      default: () => ({}),
    },
    uploadedFiles: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    filesDictionary: {
      144: {
        type: FILE,
        file: null,
        url: '',
        linkStatus: '',
        lastCheckedLink: '',
      },
      240: {
        type: FILE,
        file: null,
        url: '',
        linkStatus: '',
        lastCheckedLink: '',
      },
      360: {
        type: FILE,
        file: null,
        url: '',
        linkStatus: '',
        lastCheckedLink: '',
      },
      480: {
        type: FILE,
        file: null,
        url: '',
        linkStatus: '',
        lastCheckedLink: '',
      },
      720: {
        type: FILE,
        file: null,
        url: '',
        linkStatus: '',
        lastCheckedLink: '',
      },
      1080: {
        type: FILE,
        file: null,
        url: '',
        linkStatus: '',
        lastCheckedLink: '',
      },
    },
    FILE,
    URL,
  }),

  watch: {
    defaultFiles: {
      handler() {
        this.manuallyAddFiles();
      },
      deep: true,
    },
    uploadedFiles(val) {
      if (val) {
        Object.keys(val).forEach((quality) => {
          const dropzone = this.$refs[`dropzone${quality}`];
          if (dropzone) {
            dropzone[0].removeAllFiles();
            dropzone[0].manuallyAddFile(val[quality]);
          }
        });
      }
    },
  },

  mounted() {
    if (this.defaultFiles && Object.keys(this.defaultFiles).length) {
      this.manuallyAddFiles();
    }
  },

  methods: {
    videoAdded(file, quality) {
      this.filesDictionary[quality].file = file;
      this.emitChange();
    },
    videoRemoved(file, quality) {
      this.filesDictionary[quality].file = null;
      this.emitChange();
    },
    checkLink(quality) {
      const { url, lastCheckedLink } = this.filesDictionary[quality];
      if (!url) return;
      if (lastCheckedLink === url) return;
      this.filesDictionary[quality].linkStatus = 'loading';
      this.filesDictionary[quality].lastCheckedLink = url;
      const postFormData = new FormData();
      postFormData.append(`selectel_file_url_${quality}`, url);
      postFormData.append('content_type', this.checkType);
      this.$apiHttp.post(`${this.$config.app_api.prefix}selectel/check-link`, postFormData)
        .then(() => {
          this.filesDictionary[quality].linkStatus = 'ok';
        })
        .catch(() => {
          this.filesDictionary[quality].linkStatus = 'error';
        });
    },
    attachFile(url, quality) {
      this.filesDictionary[quality].url = url;
      this.checkLink(quality);
    },
    manuallyAddFiles() {
      this.qualityArray.forEach((quality) => {
        const item = this.defaultFiles[+quality];
        if (!item) return;
        const newFile = {
          file: {
            name: item.file_name,
            size: item.size,
          },
          url: item.url,
          thumb: item.thumbnail,
        };
        const dropzone = this.$refs[`dropzone${quality}`][0];
        dropzone.removeAllFiles();
        dropzone.manuallyAddFile(newFile.file, newFile.url);
        if (!item.mime_type.match(/image.*/)) {
          $(`#files-uploader-${quality} .dz-preview`).last()
            .find('.dz-image img').attr('src', newFile.thumb);
        }
      });
    },
    onSelectelUploaderClick(quality) {
      this.filesDictionary[quality].type = URL;
      this.emitChange();
    },
    onFileUploaderClick(quality) {
      this.filesDictionary[quality].type = FILE;
      this.emitChange();
    },
    emitChange() {
      this.$emit('content-change', {
        ...this.filesDictionary,
      });
    },
  },
};
</script>

<style>
  .file-uploader__multiple-dropzone {
    border: 1px solid lightgray;
    padding: 10px;
  }

  .files-uploader__select-row {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .files-uploader__select-row:last-child {
    margin-bottom: 0;
  }

  .file-uploader__dropzone-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
  }

  .file-uploader__dropzone-list-item {
    width: calc(33.33% - 10px);
    margin-right: 10px;
    padding: 10px;
    background: #ebedef;
  }
  .file-uploader__dropzone-list-item .vue-dropzone {
    width: 100%;
    height: 276px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(0,0,0,0.15);
  }
  .file-uploader__dropzone-list-item:nth-child(n + 4) {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// VideoQualityUploader.vue?07e59ba4